import api from '../../api/apiService';
import { SavedSearchDto } from '../../models/SavedSearch';
import { getSortedSavedSearches } from '../../utils/searches';
import { getCurrentUser } from '../auth';

const savedSearchesUri = (userId: string) => `/profile/v1/profiles/${userId}/searches`;

export const fetchSortedSavedSearches = async (): Promise<SavedSearchDto[]> => {
  const { userId } = getCurrentUser();
  if (!userId) {
    throw new Error('Failed to get userId');
  }

  const { data } = await api.get<SavedSearchDto[]>(savedSearchesUri(userId));
  return getSortedSavedSearches(data);
};
